/* eslint max-len:0 */
const Bulgarian = {
    _language: 'bulgarian',
    _language_short: 'bg',
    agentWelkomMessage: 'Добре дошли. Задайте въпроса си тук.',
    conversationTimestampHeaderFormat: 'HH:mm',
    couldNotConnect: 'Неуспешно свързване. Можете да {retry}',
    couldNotConnectInner: 'опитайте отново',
    couldNotConnectWithRetry: 'Неуспешно свързване. Ще продължим да опитваме, или можете да {retry}.',
    couldNotConnectWithRetryInner: 'опитайте сега',
    headerText: 'Как можем да помогнем?',
    imageClickToReload: 'Кликнете, за да презаредите изображението.',
    imageClickToView: 'Кликнете, за да видите изображението с размер {size}.',
    imagePreviewNotAvailable: 'Прегледът не е наличен.',
    inputPlaceholder: 'Пишете тук и натиснете <enter>, за да изпратите.',
    inputPlaceholderBlocked: 'Попълнете формуляра по-горе...',
    introAppText: 'Изпратете съобщението си по-долу или през любимия си канал.',
    introductionText: 'Задайте въпроса си тук.',
    actionPaymentCompleted: 'Плащането е получено.',
    actionPaymentError: 'Възникна грешка при обработката на плащането. <br> Моля, опитайте отново или използвайте друга карта.',
    actionPostbackError: 'Възникна грешка при обработката на действието ви. Моля, опитайте отново.',
    clickToRetry: 'Съобщението не беше доставено. Моля, опитайте отново.',
    clickToRetryForm: 'Формулярът не беше изпратен. Кликнете върху формуляра, за да опитате отново.',
    connectNotificationText: 'Изчакайте отговор или изберете приложение, в което да продължите.',
    connectNotificationSingleText: 'Изчакайте отговор или изберете приложение, в което да продължите.',
    connectNotificationSingleButtonText: 'Включете известията за <name>',
    connectNotificationOthersText: 'други',
    emailChangeAddress: 'Промяна на имейл адреса ми',
    emailDescription: 'За да получите известие по имейл при отговор, въведете имейл адреса си.',
    emailFieldLabel: 'Вашият имейл',
    emailFieldPlaceholder: 'Вашият имейл адрес',
    emailFormButton: 'Продължи',
    fetchHistory: 'Зареди още',
    fetchingHistory: 'Извличане на история...',
    frontendEmailChannelDescription: 'Изпратете ни имейл и ще ви отговорим възможно най-скоро.',
    invalidFileError: 'Поддържат се само изображения. Изберете файл с поддържан формат (jpg, jpeg, png, gif или bmp).',
    lineChannelDescription: 'Сканирайте QR кода, за да разговаряте с нас чрез LINE.',
    locationNotSupported: 'Вашият браузър не поддържа услуги за местоположение или те са деактивирани. Моля, въведете местоположението си.',
    locationSecurityRestriction: 'Този уебсайт няма достъп до вашето местоположение. Моля, въведете го ръчно.',
    locationSendingFailed: 'Неуспешно изпращане на местоположение',
    locationServicesDenied: 'Този уебсайт няма достъп до вашето местоположение. Разрешете достъп в настройките или въведете местоположението си.',
    messageError: 'Възникна грешка при изпращането на съобщението. Моля, опитайте отново.',
    messageIndicatorTitlePlural: '({count}) Нови съобщения',
    messageIndicatorTitleSingular: '({count}) Ново съобщение',
    messageRelativeTimeDay: 'преди {value} дни',
    messageRelativeTimeHour: 'преди {value} ч.',
    messageRelativeTimeJustNow: 'Току-що',
    messageRelativeTimeMinute: 'преди {value} мин.',
    messageTimestampFormat: 'h:mm A',
    messageSending: 'Изпращане...',
    messageDelivered: 'Доставено',
    messengerChannelDescription: 'Свържете вашия Facebook акаунт, за да продължите през Facebook Messenger.',
    whatsappChannelDescriptionDesktop: 'Започнете или продължете разговора си чрез WhatsApp. Кликнете на линка по-долу.',
    whatsappChannelDescriptionMobile: 'Започнете или продължете разговора си чрез WhatsApp. Кликнете на линка по-долу.',
    whatsappLinkingError: 'Възникна грешка при свързването. Моля, опитайте отново.',
    notificationSettingsChannelsDescription: 'Можете също да се свържете с нас чрез любимото си приложение или услуга.',
    notificationSettingsChannelsTitle: 'Други приложения',
    notificationSettingsConnected: 'Свързано',
    notificationSettingsConnectedAs: 'Свързано като {username}',
    prechatCaptureGreetingText: 'Здравейте 👋\nЗа начало, бихме искали да научим малко повече за вас:',
    prechatCaptureNameLabel: 'Вашето име',
    prechatCaptureNamePlaceholder: 'Въведете името си...',
    prechatCaptureEmailLabel: 'Имейл',
    prechatCaptureEmailPlaceholder: 'name@company.com',
    prechatCaptureConfirmationText: 'Благодарим! С какво можем да помогнем?',
    prechatCaptureMailgunLinkingConfirmation: 'Ще получите известие тук и на имейл {email}, когато отговорим.',
    sendButtonText: 'Изпрати',
    settingsHeaderText: 'Настройки',
    smsBadRequestError: 'Не успяхме да се свържем с този номер. Опитайте отново или използвайте друг номер.',
    smsCancel: 'Отказ',
    smsChangeNumber: 'Промяна на номера ми',
    smsChannelDescription: 'Свържете вашия SMS номер, за да продължите чрез SMS.',
    smsChannelPendingDescription: 'Проверете съобщенията си на {number}, за да потвърдите телефонния си номер.',
    smsContinue: 'Продължи',
    smsInvalidNumberError: 'Телефонният ви номер не е валиден. Моля, опитайте отново.',
    smsLinkCancelled: 'Връзката към {appUserNumber} беше отменена.',
    smsLinkPending: 'В изчакване',
    smsPingChannelError: 'Възникна грешка при изпращане на съобщение до вашия номер.',
    smsSendText: 'Изпратете ми съобщение',
    smsStartTexting: 'Започнете чат',
    smsTooManyRequestsError: 'Наскоро беше поискано свързване за този номер. Моля, опитайте отново след {minutes} минути.',
    smsTooManyRequestsOneMinuteError: 'Наскоро беше поискано свързване за този номер. Моля, опитайте отново след 1 минута.',
    smsUnhandledError: 'Нещо се обърка. Моля, опитайте отново.',
    tapToRetry: 'Съобщението не беше доставено. Натиснете Enter, за да опитате отново.',
    tapToRetryForm: 'Формулярът не беше изпратен. Докоснете където и да е върху формуляра, за да опитате отново.',
    telegramChannelDescription: 'Свържете вашия Telegram акаунт, за да продължите чрез Telegram.',
    unsupportedMessageType: 'Неподдържан тип съобщение.',
    unsupportedActionType: 'Неподдържан тип действие.',
    linkError: 'Възникна грешка при опита за генериране на връзка за този канал. Моля, опитайте отново.',
    viberChannelDescription: 'Свържете вашия Viber акаунт, за да продължите чрез Viber.',
    viberChannelDescriptionMobile: 'Свържете вашия Viber акаунт, за да получавате известия при нов отговор и да продължите разговора във Viber. За да започнете, инсталирайте приложението Viber и натиснете "Свържи".',
    viberQRCodeError: 'Възникна грешка при извличането на вашия Viber QR код. Моля, опитайте отново.',
    wechatChannelDescription: 'Свържете вашия WeChat акаунт, за да получавате известия при нов отговор и да продължите разговора в WeChat. За да започнете, сканирайте този QR код с приложението WeChat.',
    wechatChannelDescriptionMobile: 'Свържете вашия WeChat акаунт, за да получавате известия при нов отговор и да продължите разговора в WeChat. За да започнете, запазете този QR код като изображение и го качете в <a href="weixin://dl/scan">QR код скенер</a>.',
    wechatQRCodeError: 'Възникна грешка при извличането на вашия WeChat QR код. Моля, опитайте отново.',
    fileTooLargeError: 'Максималният размер на файла е надвишен ({size}).',
    shareLocation: 'Сподели местоположение',
    uploadDocument: 'Качи документ',
    uploadInvalidError: 'Невалиден файл',
    fileTypeError: 'Неподдържан тип файл',
    formErrorInvalidEmail: 'Невалиден имейл',
    formErrorNoLongerThan: 'Трябва да съдържа не повече от ({characters}) символа.',
    formErrorNoShorterThan: 'Трябва да съдържа поне ({characters}) символа.',
    formErrorUnknown: 'Изглежда нещо не е наред.',
    formFieldSelectPlaceholderFallback: 'Изберете една от опциите...',
    uploadPhoto: 'Качи снимка',
    uploadVirusError: 'Открит е вирус във вашия файл и той беше отхвърлен.',
    shoutoutText: 'Започнете чат',
    cardClickText: 'Избрано'
};
export { Bulgarian };
